<template>
    <WelcomeCreditsDialog />
    <router-view></router-view>
</template>
<script setup lang="ts">
import { controlDeferred } from '@eureka/utils/control';
import { UsageAmountWhere } from '@eureka/shared/edition-upgrade/src/constants';
import { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';
import { WelcomeCreditsDialog } from '@eureka/shared/welcome-credits-dialog';
import { handlePaymentSuccess } from '@eureka/startup/src/handle-payment-success';
import { openPackageStatusDialog } from '@eureka/shared/enterprise-rule';
import { onMounted } from 'vue';
import { accountDeferred } from '@eureka/utils/account';

async function openEditionUpgradeFirstLogin() {
    const { is_first_login_after_try_end } = await controlDeferred.promise;
    if (is_first_login_after_try_end) {
        import('@eureka/shared/edition-upgrade').then((mod) => {
            mod.prepareFirstLoginAfterTrial(UsageAmountWhere.TECH_SEEK, EurekaPackageType.AIR_COMMERCIAL);
        });
    }
}

openEditionUpgradeFirstLogin();
handlePaymentSuccess();

onMounted(async() => {
    const { _info: { company_id } } = await accountDeferred.promise

    if (company_id) {
        openPackageStatusDialog()
    }
})

</script>
